import deepFreeze from '../utilities/freeze';
export default deepFreeze({
    INPUT: {
        KEYBOARD: 'keyboard',
        MOUSE: 'mouse'
    }
});
